import * as types from "../constants/actionTypes";
import * as policyholderService from "../services/policyholderService";

const INVALID_QUICK_LINKS_KEYS = ["rx_card"];

const fetchQuickLinksStarted = () => ({
  type: types.FETCH_QUICK_LINKS_STARTED
});

const fetchQuickLinksSucceeded = data => ({
  type: types.FETCH_QUICK_LINKS_SUCCEEDED,
  payload: data
});

const fetchQuickLinksFailed = error => ({
  type: types.FETCH_QUICK_LINKS_FAILED,
  payload: error,
  error: true
});

export const fetchQuickLinks = userId => {
  return dispatch => {
    dispatch(fetchQuickLinksStarted());

    return policyholderService.getQuickLinks(userId).then(
      (response )=> {
        dispatch(fetchQuickLinksSucceeded(( response.data || []).filter(
        link => !INVALID_QUICK_LINKS_KEYS.includes(link?.display_key)
      )));
      },
      error => dispatch(fetchQuickLinksFailed(error.response))
    );
  };
};
